import { Redux } from '../..'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
  GygEonGoalsTargets,
  GygEonGoalsTargetsPayload,
  GygEonGoalsTargetsQueryOptions
} from '@/src/types/apps/gygEonGoalsTargets'

interface EonGoalsTargetsInitialState {
  goalsTargets: GygEonGoalsTargets | null
  loading: boolean
  success: string | null
  error: string | null
}

const initialState: EonGoalsTargetsInitialState = {
  goalsTargets: null,
  loading: false,
  success: null,
  error: null
}

interface EonGoalsTargetsResponse {
  data: GygEonGoalsTargets
}

export const getEonGoalsTargetsInTwoDates = createAsyncThunk<
  EonGoalsTargetsResponse,
  GygEonGoalsTargetsQueryOptions,
  Redux
>('gygEonGoalsTargets/getEonGoalsTargetsInTwoDates', async (gygEonGoalsTargetsQueryOptions, { extra }) => {
  const { restaurantId, startDate, endDate } = gygEonGoalsTargetsQueryOptions

  const { data: responseData } = await extra.httpClient.get(`restaurants/${restaurantId}/eon-goals-targets/latest`, {
    params: {
      startDate,
      endDate
    }
  })

  return responseData
})

export const saveEonGoalsTargets = createAsyncThunk<void, GygEonGoalsTargetsPayload, Redux>(
  'gygEonGoalsTargets/saveEonGoalsTargets',
  async (gygEonGoalsTarget, { extra }) => {
    const { restaurantId, ...payload } = gygEonGoalsTarget

    await extra.httpClient.post(`restaurants/${restaurantId}/eon-goals-targets`, payload)
  }
)

const gygEonGoalsTargetsSlice = createSlice({
  name: 'getAllEonGoalsTargets',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getEonGoalsTargetsInTwoDates.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(getEonGoalsTargetsInTwoDates.fulfilled, (state, action) => {
        state.loading = false
        state.success = null
        state.goalsTargets = action.payload.data
      })
      .addCase(getEonGoalsTargetsInTwoDates.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message ?? 'Failed to fetch eon goals targets'
      })
      .addCase(saveEonGoalsTargets.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(saveEonGoalsTargets.fulfilled, state => {
        state.loading = false
        state.success = 'Eon goals targets saved successfully'
        state.error = null
      })
      .addCase(saveEonGoalsTargets.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message ?? 'Failed to save eon goals targets'
      })
  }
})

export default gygEonGoalsTargetsSlice.reducer
